export default __webpack_public_path__ + "static/media/logoMof.4fa63944.svg";